export const adConfig = {
  config: {
    tenant: 'pjminterconnection.onmicrosoft.com',
    clientId: 'd390d229-3584-41e6-b293-35dfc1e3aaf6',
    postLogoutRedirectUri: 'https://website-dashboard-prd.azurewebsites.net'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.config.ts